module.exports = __webpack_public_path__ + "static/Color.3a628b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Color.jpg
// module id = 388
// module chunks = 65579394461380